<router-outlet />

@if (showBookingWidget$ | async) {
  <app-ai-booking-floating-widget
    [isAuthenticated]="isAuthenticated"
    [locationQuery]="locationQuery"
  ></app-ai-booking-floating-widget>
}
